import { LegalPage } from '#app/components/legal-page.tsx'
import { type Route } from './+types/terms.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Nutzungsbedingungen · Kuratier' },
]

export default function TermsRoute() {
	return (
		<LegalPage title="Nutzungsbedingungen" updated="04.08.2026">
			<section>
				<h2>1. Geltungsbereich und Anbieter</h2>
				<p>
					(1) Diese Nutzungsbedingungen gelten für die Nutzung der Plattform
					„Kuratier" (Web-App unter kuratier.tv sowie zukünftige mobile Apps),
					betrieben von der dataso GmbH, Tilsiter Str. 1, 64342
					Seeheim-Jugenheim (nachfolgend „wir").
				</p>
				<p>(2) Abweichende Bedingungen des Nutzers finden keine Anwendung.</p>
			</section>

			<section>
				<h2>2. Leistungsbeschreibung</h2>
				<p>
					(1) Kuratier ist ein Organisations- und Empfehlungsdienst für Film-
					und Serieninhalte. Die Plattform ermöglicht es Nutzern, eigene Quellen
					(z. B. selbst beschaffte IPTV-Playlists im m3u-Format), abonnierte
					Streaming-Dienste und öffentlich-rechtliche Mediatheken in einer
					durchsuchbaren Bibliothek zu organisieren, mit frei verfügbaren
					Metadaten anzureichern und persönliche Listen sowie Bewertungen zu
					führen und mit Freunden zu teilen.
				</p>
				<p>
					(2){' '}
					<strong>
						Kuratier speichert, hostet, vermittelt oder verbreitet keine
						audiovisuellen Inhalte.
					</strong>{' '}
					Die Plattform stellt keine Streams bereit und leitet keine Streams
					über eigene Systeme durch. Wiedergaben erfolgen ausschließlich direkt
					zwischen dem Endgerät des Nutzers und der jeweiligen Quelle.
				</p>
				<p>
					(3) Die Basisnutzung ist unentgeltlich. Ein Anspruch auf bestimmte
					Funktionen, Verfügbarkeit oder Fortbestand des unentgeltlichen
					Dienstes besteht nicht; wir können Funktionsumfang und Dienst mit
					angemessener Ankündigungsfrist ändern oder einstellen.
				</p>
			</section>

			<section>
				<h2>3. Registrierung und Konto</h2>
				<p>
					(1) Die Nutzung setzt ein Konto voraus (E-Mail-Adresse, Alias,
					Passwort). Der Nutzer sichert zu, dass die Angaben zutreffend sind und
					er mindestens 18 Jahre alt ist.
				</p>
				<p>
					(2) Zugangsdaten sind geheim zu halten. Der Nutzer informiert uns
					unverzüglich bei Verdacht auf Missbrauch seines Kontos.
				</p>
			</section>

			<section>
				<h2>4. Pflichten des Nutzers; eingebrachte Quellen</h2>
				<p>
					(1) Der Nutzer darf ausschließlich Quellen einbinden, zu deren Nutzung
					er berechtigt ist.{' '}
					<strong>
						Die Einbindung von Quellen, die offensichtlich rechtswidrig Inhalte
						zugänglich machen, ist untersagt.
					</strong>
				</p>
				<p>
					(2) Der Nutzer allein ist für die Rechtmäßigkeit der von ihm
					eingebundenen Quellen verantwortlich. Wir prüfen eingebundene Quellen
					nicht auf ihre Rechtmäßigkeit und haben hierzu keine tatsächliche
					Kenntnisnahme; Playlists sind ausschließlich für den jeweiligen Nutzer
					sichtbar.
				</p>
				<p>
					(3) Untersagt ist insbesondere: Playlists oder Stream-URLs über die
					Plattform Dritten zugänglich zu machen; die Plattform zur Bewerbung,
					zum Verkauf oder Tausch von IPTV-Zugängen zu nutzen; automatisierte
					Massenabfragen; Eingriffe in die technische Infrastruktur.
				</p>
				<p>
					(4) In Community-Bereichen (Bewertungen, Kommentare, Wall) sind
					rechtswidrige, beleidigende, jugendgefährdende und werbliche Inhalte
					untersagt.
				</p>
			</section>

			<section>
				<h2>5. Community-Inhalte und Rechteeinräumung</h2>
				<p>
					(1) Für selbst erstellte Inhalte (Bewertungen, Kommentare) räumt der
					Nutzer uns das einfache, widerrufliche Recht ein, diese im Rahmen der
					Plattform (Anzeige im Freundes-Feed) zu nutzen.
				</p>
				<p>
					(2) Wir können Community-Inhalte entfernen, die gegen Ziffer 4
					verstoßen.
				</p>
			</section>

			<section>
				<h2>6. Meldeverfahren (Notice and Action)</h2>
				<p>
					(1) Hinweise auf rechtswidrige Inhalte oder Nutzungen können an{' '}
					<a href="mailto:dawid@dataso.de">dawid@dataso.de</a> gerichtet werden.
				</p>
				<p>
					(2) Wir prüfen begründete Meldungen unverzüglich und ergreifen
					erforderliche Maßnahmen (z. B. Entfernung von Community-Inhalten,
					Sperrung von Funktionen oder Konten). Der betroffene Nutzer wird —
					soweit rechtlich zulässig — informiert und kann Stellung nehmen.
				</p>
			</section>

			<section>
				<h2>7. Sperrung und Kündigung</h2>
				<p>
					(1) Der Nutzer kann sein Konto jederzeit löschen; die zugehörigen
					Daten werden gemäß Datenschutzerklärung gelöscht.
				</p>
				<p>
					(2) Wir können Konten bei Verstößen gegen Ziffer 4 nach Abmahnung —
					bei schwerwiegenden Verstößen auch sofort — sperren oder kündigen.
				</p>
			</section>

			<section>
				<h2>8. Metadaten und Drittdienste</h2>
				<p>
					Metadaten (Cover, Bewertungen, Trailer) stammen aus Drittquellen (u.
					a. TMDB, OMDb), Verfügbarkeitsdaten von JustWatch, Chartdaten aus
					öffentlich publizierten Quellen. Für Richtigkeit und Vollständigkeit
					dieser Fremddaten übernehmen wir keine Gewähr; Markenrechte verbleiben
					bei den jeweiligen Inhabern.
				</p>
			</section>

			<section>
				<h2>9. Haftung</h2>
				<p>
					(1) Wir haften unbeschränkt bei Vorsatz, grober Fahrlässigkeit sowie
					bei Verletzung von Leben, Körper und Gesundheit.
				</p>
				<p>
					(2) Bei einfacher Fahrlässigkeit haften wir nur für die Verletzung
					wesentlicher Vertragspflichten (Kardinalpflichten), begrenzt auf den
					vorhersehbaren, vertragstypischen Schaden.
				</p>
				<p>
					(3) Für die unentgeltliche Bereitstellung gelten im Übrigen die
					gesetzlichen Haftungsmaßstäbe für unentgeltliche Leistungen.
				</p>
				<p>
					(4) Für die Rechtmäßigkeit, Verfügbarkeit und Qualität der vom Nutzer
					eingebundenen Quellen übernehmen wir keine Verantwortung.
				</p>
			</section>

			<section>
				<h2>10. Änderungen dieser Bedingungen</h2>
				<p>
					Änderungen werden registrierten Nutzern mindestens sechs Wochen vor
					Wirksamwerden in Textform angekündigt. Widerspricht der Nutzer nicht
					innerhalb der Frist oder nutzt er die Plattform danach weiter, gelten
					die geänderten Bedingungen; auf diese Folge weisen wir in der
					Ankündigung gesondert hin. Wesentliche Änderungen des Leistungsgefüges
					bedürfen der aktiven Zustimmung.
				</p>
			</section>

			<section>
				<h2>11. Schlussbestimmungen</h2>
				<p>
					(1) Es gilt deutsches Recht. Gegenüber Verbrauchern gilt diese
					Rechtswahl nur, soweit ihnen dadurch nicht der Schutz zwingender
					Bestimmungen ihres Aufenthaltsstaates entzogen wird.
				</p>
				<p>
					(2) Sollten einzelne Bestimmungen unwirksam sein, bleibt die
					Wirksamkeit im Übrigen unberührt.
				</p>
			</section>
		</LegalPage>
	)
}
